import { createCustomSlice } from 'core/utils';

const initialState = {
    blocked: false,
    folders: [],
    loading: false,
    status: ''
};

const fileSlice = createCustomSlice({
    initialState,
    name: 'file',
    reducers: {},
    saga: [
        'createFile',
        'createFolder',
        'deleteFile',
        'deleteFolder',
        'downloadFile',
        'getFile',
        'getFileFolders',
        'updateFile',
        'updateFolder'
    ]
});

export const fileActions = fileSlice.actions;

export default fileSlice.reducer;
